import { ACTIONS } from 'tracker.constants';

export default function privatePackageTracker(state = {}, action) {
  if (action.type === ACTIONS.SAVE_PRIVATE_PACKAGE) {
    return action.data;
  }
  return state;
}
